import React from 'react';
import PropTypes from 'prop-types';
import { ListItem } from '@mui/material';

import CustomRowList from 'src/components/ui/list/custom-row-list';
import HeaderCellText from 'src/components/ui/list/header-cell-text';
import ListCellText from 'src/components/ui/list/list-cell-text';

export const TrackingTable = ({items}) => {

  const renderItem = (item, rowSx, idx) => (
    <ListItem
      divider={true}
      key={idx}
      disablePadding
      sx={{
        ...rowSx,
        px: 1,
        py: 1,
      }}
    >
      <ListCellText flex="0 0 5%" color='primary.main' primary={item.trackingStep} />
      <ListCellText flex="0 0 15%" primary={item.trackingName} />
      <ListCellText flex="0 0 15%" primary={item.statusName} />
      <ListCellText flex="0 0 15%" color='text.secondary' align='right' primary={item.updatedDate} />
      <ListCellText flex="0 0 15%" color='text.secondary' align='right' primary={item.remindDate} />
      <ListCellText flex="0 0 35%" color='text.secondary' align='right' primary={item.note} />
    </ListItem>
  );

  return (
    <CustomRowList
      items={items} 
      renderItem={renderItem}
      sx={{
        height: '100%',
      }}
    >
      <HeaderCellText sx={{ width: '5%' }}>Stt</HeaderCellText>
      <HeaderCellText sx={{ width: '15%' }}>Tiến độ</HeaderCellText>
      <HeaderCellText sx={{ width: '15%' }}>Trạng Thái</HeaderCellText>
      <HeaderCellText sx={{ width: '15%', textAlign: 'right' }}>Ngày cập nhật</HeaderCellText>
      <HeaderCellText sx={{ width: '15%', textAlign: 'right' }}>Ngày ghi chú</HeaderCellText>
      <HeaderCellText sx={{ width: '35%', textAlign: 'right' }}>Ghi chú</HeaderCellText>
    </CustomRowList>
  );
};

TrackingTable.propTypes = {
  items: PropTypes.array.isRequired,
};
